import React, { PureComponent } from 'react'
import { DsStack, DsTypography } from '@am92/react-design-system'

import getWithPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import PageWrapper from '~/src/Components/PageWrapper'
import StaticContent from '~/src/Components/StaticContent'

import TERMS_AND_CONDITIONS_PAGE_CONSTANTS from './TermsAndConditions.PageConstants'
import { T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS } from './TermsAndConditions.PageConstants/TYPES'

export interface ITermsAndConditionsPageProps
  extends IWithPageConstantsProps<T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS> {}

class TermsAndConditionsPage extends PureComponent<ITermsAndConditionsPageProps> {
  render() {
    const { PAGE_CONSTANTS } = this.props
    return (
      <PageWrapper>
        <DsStack direction='column' spacing='var(--ds-spacing-frostbite)'>
          <DsTypography variant='subheadingSemiboldLarge'>
            {PAGE_CONSTANTS.PAGE_KICKER}
          </DsTypography>
          <DsTypography variant='displayBoldMedium'>
            {PAGE_CONSTANTS.PAGE_TITLE}
          </DsTypography>
        </DsStack>
        <StaticContent pageContent={PAGE_CONSTANTS.PAGE_CONTENT} />
      </PageWrapper>
    )
  }
}

const withPageConstants =
  getWithPageConstants<T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS>(
    TERMS_AND_CONDITIONS_PAGE_CONSTANTS
  )

export default withPageConstants(TermsAndConditionsPage)
